import React, { FC } from 'react'
import { ButtonLink } from 'components/ButtonLink'
import { Card } from 'components/Card'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icon'
import { Stack } from 'components/Stack'
import { Flex } from 'components/Flex'
import { Logo } from 'features/shared/Logo'
import styles from './NotFound.module.scss'

export const NotFound: FC = (_props) => {
  const { t } = useTranslation()

  return (
    <Flex justify="center" align="center" className={styles.notFound}>
      <Card className={styles.card}>
        <Stack space="xlarge">
          <Stack space="small">
            <Heading>{t('not_found.title')}</Heading>
            <Text>{t('not_found.subtitle')}</Text>
          </Stack>
          <ButtonLink to="/">{t('not_found.cta')}</ButtonLink>
          <Logo />
        </Stack>
        <Icon name="alert-line" className={styles.icon} />
      </Card>
    </Flex>
  )
}

NotFound.displayName = 'NotFound'
